<template>
  <el-dialog
    :visible.sync="visible"
    width="551px"
    :close-on-click-modal="false"
    :before-close="handleClose"
    class="company-search-dialog"
  >
    <div class="dialog-wrapper">
      <!-- 背景图片 -->
      <img class="bg-image" src="@/assets/img/authenticationBg.png" alt="" />
      <div class="dialog-content">
        <div class="dialog-header">
          <div class="header-icon">
            <img :src="titleImg()" alt="" />
          </div>
          <div
            class="header-title"
            :style="{
              color:
                activeStep === 3 || activeStep === 6 ? '#FF383C' : '#3b75dd',
            }"
          >
            {{ dialogTitle }}
          </div>
          <div class="close-btn" @click="handleClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <!-- 第一个内容企业检索 -->
        <div v-if="activeStep === 1" class="dialog-content-top">
          <div class="dialog-body">
            <div class="tips-text">
              您暂未完成企业实名认证，<br />
              请先完成企业实名认证，感谢您的理解！
            </div>

            <!-- 企业搜索框 -->
            <div class="company-search">
              <div class="search-pill">
                <span class="search-label">按企业名称</span>
                <span class="search-sep"></span>
                <input
                  class="search-input"
                  type="text"
                  placeholder="请输入企业名称"
                  v-model="companyName"
                  @keyup.enter="search"
                />
                <el-button
                  type="primary"
                  class="search-btn"
                  @click="search"
                  :loading="loading"
                >
                  查询
                </el-button>
              </div>
            </div>

            <!-- 企业列表 -->
            <div
              v-loading="loading"
              class="company-list"
              v-if="list.length > 0"
            >
              <div
                v-for="(item, index) in list"
                :key="index"
                class="company-item"
                :class="{ active: selected === index }"
                @click="selectCompany(index)"
              >
                <div class="company-name">{{ item.companyName }}</div>
                <div class="company-code">{{ maskCode(item.usci) }}</div>
              </div>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper" v-if="total > 0">
              <el-pagination
                small
                background
                @current-change="handlePageChange"
                :current-page="current"
                :page-size="5"
                layout="prev, pager, next"
                :total="total"
              >
              </el-pagination>
            </div>

            <!-- 无数据 -->
            <div class="no-data" v-if="searched && list.length === 0">
              <i class="el-icon-search"></i>
              <p>未找到相关企业</p>
            </div>
          </div>
          <div class="dialog-footer">
            <span class="skip-btn" @click="handleClose">暂不认证</span>
          </div>
        </div>
        <!-- 第二个内容获取验证信息 -->
        <div v-if="activeStep === 2" class="dialog-content-top">
          <div class="dialog-body">
            <div class="verify-info">
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/companyName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>公司名称</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.companyName }}</span>
                    <img
                      src="@/assets/img/Update.png"
                      alt=""
                      class="edit-icon"
                      @click="goBackToSearch"
                    />
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/personName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人姓名</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.legalName }}</span>
                  </div>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/institutionCode.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>企业统一社会信用代码</span>
                  </div>
                  <div class="info-value">
                    <span>{{ enterpriseCode(selectedCompany.usci) }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/LegaNumberl.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人身份证号</span>
                  </div>
                  <div class="info-value">
                    <input
                      class="id-input"
                      type="text"
                      placeholder="请输入法人身份证号"
                      v-model="legalIdNo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <el-button type="primary" class="verify-btn" @click="getVerifyInfo">
              获取验证信息
            </el-button>
            <div>
              <span class="skip-btn" @click="handleClose">暂不认证</span>
            </div>
          </div>
        </div>
        <!-- 第三个内容经营状态异常 -->
        <div v-if="activeStep === 3" class="dialog-content-top">
          <div class="dialog-body">
            <div class="verify-info">
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/companyName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>公司名称</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.companyName }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/personName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人姓名</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.legalName }}</span>
                  </div>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/institutionCode.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>企业统一社会信用代码</span>
                  </div>
                  <div class="info-value">
                    <span>{{ enterpriseCode(selectedCompany.usci) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <el-button type="primary" class="verify-btn" @click="reSelect">
              重新选择
            </el-button>
          </div>
        </div>
        <!-- 第四个内容获取认证结果 -->
        <div v-if="activeStep === 4" class="dialog-content-top">
          <div class="dialog-body">
            <div class="certify-result">
              <div class="certify-left">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/companyName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>公司名称</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.companyName }}</span>
                    <img
                      src="@/assets/img/Update.png"
                      alt=""
                      class="edit-icon"
                      @click="reSelect"
                    />
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/institutionCode.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>企业统一社会信用代码</span>
                  </div>
                  <div class="info-value">
                    <span>{{ enterpriseCode(selectedCompany.usci) }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/personName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人姓名</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.legalName }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/LegaNumberl.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人身份证号</span>
                  </div>
                  <div class="info-value">
                    <span>{{ maskCode(legalIdNo) }}</span>
                  </div>
                </div>
              </div>
              <div class="certify-right">
                <div ref="qrcodeRef" class="qrcode-box"></div>
                <div class="qrcode-tip">请使用法人支付宝扫码</div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <el-button
              type="primary"
              class="verify-btn"
              @click="getCertifyResult"
              :loading="certifyResultLoading"
            >
              已完成扫码，获取认证结果
            </el-button>
          </div>
        </div>
        <!-- 第五个内容实名认证成功 -->
        <div v-if="activeStep === 5" class="dialog-content-top">
          <div class="dialog-body">
            <div class="verify-info">
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/companyName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>公司名称</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.companyName }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/personName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人姓名</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.legalName }}</span>
                  </div>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/institutionCode.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>企业统一社会信用代码</span>
                  </div>
                  <div class="info-value">
                    <span>{{ enterpriseCode(selectedCompany.usci) }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/LegaNumberl.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人身份证号</span>
                  </div>
                  <div class="info-value">
                    <span>{{ maskCode(legalIdNo) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <el-button type="primary" class="verify-btn" @click="handleClose">
              关闭
            </el-button>
          </div>
        </div>
        <!-- 第六个内容实名认证失败 -->
        <div v-if="activeStep === 6" class="dialog-content-top">
          <div class="dialog-body">
            <div class="verify-info">
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/companyName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>公司名称</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.companyName }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/personName.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人姓名</span>
                  </div>
                  <div class="info-value">
                    <span>{{ selectedCompany.legalName }}</span>
                  </div>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/institutionCode.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>企业统一社会信用代码</span>
                  </div>
                  <div class="info-value">
                    <span>{{ enterpriseCode(selectedCompany.usci) }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-label">
                    <img
                      src="@/assets/img/LegaNumberl.png"
                      alt=""
                      class="label-icon"
                    />
                    <span>法人身份证号</span>
                  </div>
                  <div class="info-value">
                    <span>{{ maskCode(legalIdNo) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <el-button type="primary" class="verify-btn" @click="reSelect">
              重新选择
            </el-button>
            <div>
              <span class="skip-btn" @click="handleClose">暂不认证</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  fetchCompanies,
  queryCompanyIsAuth,
} from "@/api/RealNameCertification";
import { userInfo } from "@/api/login";
import { getStore } from "@/utils/auth";
import QRCode from "qrcodejs2";
export default {
  name: "RealNameCertification",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      token: getStore("token"),
      activeStep: 1, // 当前步骤：1企业检索 2获取验证信息 3经营状态异常 4获取认证结果 5认证成功 6认证失败
      dialogTitle: "温馨提示",
      companyName: "", // 企业搜索关键词
      list: [], // 企业搜索结果列表
      current: 1, // 当前分页页码
      total: 0, // 企业搜索结果总条数
      selected: null, // 当前选中企业的列表索引
      loading: false, // 企业搜索请求 loading 状态
      searched: false, // 是否已执行过搜索（用于控制"无数据"提示显示）
      selectedCompany: {}, // 用户选中的企业信息对象
      legalIdNo: "", // 输入的法人身份证号
      verifyLoading: false, // 获取验证信息按钮 loading（当前未使用，保留备用）
      certifyId: "", // 认证流程 ID（保留备用）
      certifyUrl: "", // 生成二维码所用的认证跳转 URL
      certifyResultLoading: false, // 获取认证结果按钮 loading 状态
    };
  },
  watch: {
    // 弹窗关闭时重置所有状态
    visible(val) {
      if (!val) {
        this.reset();
      }
    },
  },
  methods: {
    // 根据当前步骤返回对应的标题图标
    titleImg() {
      switch (this.activeStep) {
        case 1:
          return require("@/assets/img/authenticationIco.png"); //温馨提示
        case 2:
          return require("@/assets/img/verificationInformation.png"); //获取验证信息
        case 3:
          return require("@/assets/img/abnormalState.png"); //经营状态异常，无法认证
        case 4:
          return require("@/assets/img/CertificationResult.png"); //获取认证结果
        case 5:
          return require("@/assets/img/verificationSuccessful.png"); //实名认证成功
        case 6:
          return require("@/assets/img/verificationFailed.png"); //实名认证失败
        default:
          return require("@/assets/img/authenticationIco.png");
      }
    },

    // 重置所有数据到初始状态
    reset() {
      this.companyName = ""; // 清空搜索关键词
      this.list = []; // 清空企业列表
      this.current = 1; // 重置分页到第一页
      this.total = 0; // 清空总条数
      this.selected = null; // 清空选中索引
      this.searched = false; // 重置搜索标记
      this.selectedCompany = {}; // 清空已选企业信息
      this.legalIdNo = ""; // 清空法人身份证号
      this.activeStep = 1;
      this.dialogTitle = "温馨提示"; // 重置标题
      this.certifyId = ""; // 清空认证流程 ID
      this.certifyUrl = ""; // 清空二维码 URL
    },

    // 根据企业名称搜索企业列表
    async search() {
      if (!this.companyName || this.companyName.length < 8) {
        this.$message.warning("请输入至少8个字符的企业名称");
        return;
      }
      try {
        this.loading = true;
        this.selected = null;
        const res = await fetchCompanies({
          companyName: this.companyName,
          current: this.current,
        });
        this.loading = false;
        if (res.code === 1) {
          if (res.data.records.length === 0) {
            this.searched = true;
          }
          this.list = res.data.records;
          this.total = res.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    // 分页切换时重新查询
    handlePageChange(current) {
      this.current = current;
      this.search();
    },

    // 点击选中某家企业，进入步骤2
    async selectCompany(index) {
      const company = this.list[index];
      if (!company) return;
      try {
        this.loading = true;
        const res = await queryCompanyIsAuth({
          companyName: company.companyName,
          usci: company.usci,
        });
        if (res.code === 1) {
          this.selected = index;
          this.selectedCompany = company;
          this.activeStep = 2;
          this.dialogTitle = "获取验证信息";
        } else {
          this.$message.warning(res.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    // 返回步骤1重新搜索企业
    goBackToSearch() {
      this.activeStep = 1;
      this.dialogTitle = "温馨提示";
      this.selectedCompany = {};
      this.legalIdNo = "";
      this.search();
    },

    // 拼接认证二维码 URL，直接进入步骤4生成二维码
    getVerifyInfo() {
      if (!this.legalIdNo) {
        this.$message.warning("请输入法人身份证号");
        return;
      }
      const identityUrl = process.env.VUE_APP_IDENTITY_URL; // 从环境变量读取认证服务地址
      const token = this.token;
      const params = new URLSearchParams({
        token,
        companyName: this.selectedCompany.companyName || "",
        legalIdNo: this.legalIdNo,
        legalName: this.selectedCompany.legalName || "",
        usci: this.selectedCompany.usci || "",
      });
      this.certifyUrl = `${identityUrl}/verifyResult/face?${params.toString()}`;
      this.activeStep = 4;
      this.dialogTitle = "获取认证结果";
      this.$nextTick(() => {
        this.generateQRCode();
      });
    },

    // 在 qrcodeRef 容器中渲染二维码
    generateQRCode() {
      const el = this.$refs.qrcodeRef;
      if (!el) return;
      el.innerHTML = ""; // 清空旧二维码，防止重复渲染
      new QRCode(el, {
        text: this.certifyUrl,
        width: 115,
        height: 115,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L, //二维码容错级别
      });
    },

    // 重新选择企业：清空认证相关数据，回到步骤1
    reSelect() {
      this.activeStep = 1;
      this.dialogTitle = "温馨提示";
      this.selectedCompany = {};
      this.legalIdNo = "";
      this.certifyId = "";
      this.certifyUrl = "";
      this.search();
    },

    // 查询认证结果：调接口判断用户是否已完成实名认证
    async getCertifyResult() {
      this.certifyResultLoading = true;
      // 切换步骤前先清空二维码
      if (this.$refs.qrcodeRef) {
        this.$refs.qrcodeRef.innerHTML = "";
      }
      try {
        const res = await userInfo();
        if (res.data.isRealAuth === 1) {
          this.activeStep = 5;
          this.dialogTitle = "实名认证成功";
          this.$emit("success");
        } else {
          this.activeStep = 6;
          this.dialogTitle = "实名认证失败";
        }
      } finally {
        this.certifyResultLoading = false;
      }
    },
    // 关闭弹窗，通知父组件更新 visible
    handleClose() {
      if (this.activeStep === 5) {
        this.$emit("success");
      }
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="less" scoped>
.company-search-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    display: none;
  }

  ::v-deep .el-dialog__body {
    padding: 0;
  }
}

.dialog-wrapper {
  position: relative;
  .bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 0;
    pointer-events: none;
  }
}

.dialog-content {
  position: relative;
  z-index: 1;
}
.dialog-content-top {
  padding: 0px 40px 30px 40px;
}
.dialog-header {
  display: flex;
  align-items: center;
  position: relative;
  padding: 40px 10px 20px 40px;
  .header-icon {
    width: 20px;
    height: 20px;
    margin-right: 11px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .header-title {
    font-size: 20px;
    color: #3b75dd;
    font-weight: 500;
  }

  .close-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background: #f0f0f0;
    }

    i {
      font-size: 25px;
      color: #000000;
    }
  }
}

.dialog-body {
  .tips-text {
    font-size: 16px;
    color: #606266;
    line-height: 1.5;
    margin: 16px 0 24px 0;
  }
}

.company-search {
  margin-bottom: 20px;

  .search-pill {
    display: flex;
    align-items: center;
    height: 50px;
    background: #f5f8fd;
    border-radius: 999px;
    overflow: hidden;
    padding-right: 4px;

    .search-label {
      flex-shrink: 0;
      padding: 0 16px 0 20px;
      font-size: 14px;
      color: #303133;
    }

    .search-sep {
      flex-shrink: 0;
      width: 1px;
      height: 20px;
      background: #dcdfe6;
    }

    .search-input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      padding: 0 14px;
      font-size: 14px;
      color: #303133;
      height: 100%;

      &::placeholder {
        color: #c0c4cc;
      }
    }

    .search-btn {
      flex-shrink: 0;
      height: 38px;
      padding: 0 25px;
      border-radius: 999px;
      background: #3b75dd;
      border: none;

      &:hover {
        background: #2a5fb8;
      }
    }
  }
}

.company-list {
  margin-bottom: 15px;
  background: #f9fbff;
  border-radius: 6px 6px 6px 6px;
  .company-item {
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;

    &:hover {
      background: #f5f7fa;
    }

    &.active {
      background: #ecf5ff;
    }

    .company-name {
      font-size: 16px;
      color: #333333;
      margin-bottom: 6px;
      line-height: 24px;
    }

    .company-code {
      font-size: 16px;
      color: #333333;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.no-data {
  text-align: center;
  padding: 40px 0;
  color: #909399;

  i {
    font-size: 40px;
    margin-bottom: 10px;
  }
}

.dialog-footer {
  text-align: center;
  margin-top: 20px;
  .skip-btn {
    font-size: 14px;
    color: #333333;
    cursor: pointer;

    &:hover {
      color: #606266;
    }
  }

  .verify-btn {
    width: 100%;
    height: 50px;
    border-radius: 6px;
    font-size: 16px;
    background: #3b75dd;
    border: none;
    margin-bottom: 16px;

    &:hover {
      background: #2a5fb8;
    }
  }
}

.verify-info {
  margin-top: 20px;

  .info-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }

  .info-item {
    flex: 1;

    .info-label {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .label-icon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      span {
        font-size: 14px;
        color: #909399;
      }
    }

    .info-value {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #3b75dd;
      font-weight: 500;
      min-height: 30px;

      .edit-icon {
        width: 16px;
        height: 16px;
        margin-left: 8px;
        cursor: pointer;
        opacity: 0.7;

        &:hover {
          opacity: 1;
        }
      }

      .id-input {
        width: 100%;
        border: none;
        outline: none;
        font-size: 16px;
        color: #303133;
        background: transparent;
        padding: 0;

        &::placeholder {
          color: #c0c4cc;
        }
      }
    }
  }
}

.certify-result {
  display: flex;
  margin-top: 20px;
  gap: 20px;

  .certify-left {
    flex: 1;

    .info-item {
      margin-bottom: 23px;

      .info-label {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .label-icon {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }

        span {
          font-size: 14px;
          color: #909399;
        }
      }

      .info-value {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #3b75dd;
        font-weight: 500;

        .edit-icon {
          width: 16px;
          height: 16px;
          margin-left: 8px;
          cursor: pointer;
          opacity: 0.7;

          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .certify-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 65px;

    .qrcode-box {
      width: 115px;
      height: 115px;
      border-radius: 4px;
      overflow: hidden;
    }

    .qrcode-tip {
      margin-top: 20px;
      font-size: 16px;
      color: #333333;
      font-weight: 500;
    }
  }
}
</style>
